import { ContractChangeValidationListFragment } from '../../../../types'
import { getUndefinedContractChangeValuesForGivenMonth } from './validationHelpers'

export type SalaryChangeValidationType = {
  valid: boolean
  minimalValidValue?: number
}

export const salaryChangeValidation = (
  date: Date,
  salary: number,
  contractChangeValidationList: ContractChangeValidationListFragment,
): SalaryChangeValidationType => {
  const minimalValidValue: number = getUndefinedContractChangeValuesForGivenMonth(date, contractChangeValidationList).salary
  if (salary <= minimalValidValue) {
    return {
      valid: false,
      minimalValidValue: minimalValidValue,
    }
  }

  return { valid: true }
}
